<template>
  <div class="d-flex just-center align-center">
    <button v-if="newIsWatched" @click="handleToggle">
      <v-icon color="#FFAB00" size="30">
        mdi-star
      </v-icon>
    </button>
    <button v-else @click="handleToggle">
      <v-icon color="#FFAB00" size="30">
        mdi-star-outline
      </v-icon>
    </button>
  </div>
</template>

<script>
import adminMixin from '@shared/mixins/adminMixin';

export default {
  name: 'WatchlistButton',
  mixins: [adminMixin],
  props: {
    customerId: Number,
    uid: String,
  },
  data() {
    return {
      newIsWatched: false,
    };
  },
  computed: {
    isWatched() {
      return this.watchlistData?.find((x) => x.customerId === this.customerId || x.uid === this.uid);
    },
  },
  watch: {
    isWatched(nv) {
      this.newIsWatched = nv;
    },
  },
  async mounted() {
    await this.$store.dispatch('getWatchlistData');
  },
  methods: {
    async handleToggle() {
      const newVal = !this.newIsWatched;
      this.newIsWatched = !this.newIsWatched;
      if (this.isWatched) {
        await this.$store.dispatch('updateWatchlist', { ...this.isWatched, isActive: newVal });
      } else {
        await this.$store.dispatch('createWatchlist', { customerId: this.customerId, uid: this.uid });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
